"use strict";

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPersonFilled = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPersonFilled = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.37639 4.99948H4.40946C6.54309 4.99948 7.02485 6.99382 6.99903 7.99099V8.99784L6.99904 9.75061C6.99904 9.75061 6.90126 10 6.78147 10L0.259889 9.98499C0.173236 9.95069 0 9.84199 0 9.68184V7.98161C0 6.21548 0.82965 4.99948 2.37639 4.99948Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.39254 0C4.46488 0 5.3384 1.01059 5.3384 2.24993C5.3384 3.48834 4.46488 4.49987 3.39254 4.49987C2.31937 4.49987 1.44667 3.48834 1.44667 2.24993C1.44667 1.01059 2.31937 0 3.39254 0Z",
      fill: color
    }, void 0)]
  }, void 0);
});